import { useState } from "react";

import {
  CCard,
  CCardBody,
  CCardHeader,
  CCollapse,
} from "@coreui/react";
import {
  ReceivedDocument,
  DOCUMENT_TYPE_LABELS,
} from "../../models/received-document";
import { formatUTCDateTime } from "../../utils/dates";
import { formatToCurrency } from "../../currency/format";
import ReceivedDocumentCrudActions from "./ReceivedDocumentCrudActions";
import PermissionRequiredComponent from "../permissions/PermissionRequiredComponent";
import { RECEIVED_DOCUMENTS_RETRIEVE } from "../../auth/permissions";

interface ReceivedDocumentCardProps {
  document: ReceivedDocument;
  onReadClick: (doc: ReceivedDocument) => void;
  onUpdateClick: (doc: ReceivedDocument) => void;
  onDeleteClick: (doc: ReceivedDocument) => void;
}

export function ReceivedDocumentMobileCard({
  document,
  onReadClick,
  onUpdateClick,
  onDeleteClick,
}: ReceivedDocumentCardProps) {
  const [open, setOpen] = useState(true);

  const supplierInfo =
    document.supplierRuc && document.supplierSocialName
      ? `${document.supplierRuc} - ${document.supplierSocialName}`
      : (document.supplierSocialName ?? "-");

  const typeLabel = document.documentType
    ? (DOCUMENT_TYPE_LABELS[document.documentType] ?? document.documentType)
    : "-";

  return (
    <CCard className="mb-2">
      <CCardHeader
        className="d-flex justify-content-between align-items-center cursor-pointer"
        onClick={() => setOpen(!open)}
      >
        <span>
          <strong>{document.documentNumber ?? "-"}</strong>
        </span>
        <span className="d-flex align-items-center gap-2">
          <strong>
            {document.documentDate
              ? formatUTCDateTime(new Date(document.documentDate))
              : "-"}
          </strong>
          <span
            className="rounded-circle bg-white d-flex justify-content-center align-items-center ml-1"
            style={{ width: "22px", height: "22px" }}
          >
            <i
              className={`fa fa-chevron-${open ? "up" : "down"}`}
              style={{ color: "black", fontSize: "12px" }}
            />
          </span>
        </span>
      </CCardHeader>
      <CCollapse show={open}>
        <CCardBody>
          <p>
            <strong>Tipo:</strong> {typeLabel}
          </p>
          <p>
            <strong>Emisor:</strong> {supplierInfo}
          </p>
          <p>
            <strong>Total:</strong>{" "}
            {document.amount !== undefined && document.currency
              ? formatToCurrency(document.amount, document.currency)
              : "-"}
          </p>
          <p>
            <strong>IVA 10%:</strong>{" "}
            {document.iva10Percent !== undefined && document.currency
              ? formatToCurrency(document.iva10Percent, document.currency)
              : "-"}
          </p>
          <p>
            <strong>IVA 5%:</strong>{" "}
            {document.iva5Percent !== undefined && document.currency
              ? formatToCurrency(document.iva5Percent, document.currency)
              : "-"}
          </p>
          <div>
            <strong>Acciones disponibles:</strong>{" "}
            <PermissionRequiredComponent
              permissionName={RECEIVED_DOCUMENTS_RETRIEVE}
            >
              <ReceivedDocumentCrudActions
                document={document}
                onReadClick={onReadClick}
                onUpdateClick={onUpdateClick}
                onDeleteClick={onDeleteClick}
              />
            </PermissionRequiredComponent>
          </div>
        </CCardBody>
      </CCollapse>
    </CCard>
  );
}
